import theme from "themes/Theme";
import { IconProps } from "./IconProps";
import { alpha } from "@mui/material";

const ReceiveIcon: React.FC<IconProps> = ({ width = 64, height = 64 }) => {
  return (
    <svg viewBox="0 0 24 24" width={width} height={height}>
      <path
        d="M21.971,8.92,17.769,7.3a.75.75,0,1,0-.539,1.4l2.168.835a.25.25,0,0,1,0,.466l-7.309,2.924a.257.257,0,0,1-.185,0L4.569,9.989a.249.249,0,0,1,0-.466L6.763,8.7a.75.75,0,1,0-.527-1.4L1.978,8.9a.769.769,0,0,0-.479.72v8.917a.5.5,0,0,0,.277.447l10,4.969.014,0a.472.472,0,0,0,.419,0l.014,0,10-4.969a.5.5,0,0,0,.276-.447V9.5C22.5,9.488,22.547,9.141,21.971,8.92Z"
        fill={alpha(theme.palette.primary.main, 1)}
      />
      <path
        d="M11.2,10.1a1,1,0,0,0,1.6,0l3-4A1,1,0,0,0,15,4.5H13.5v-3a1.5,1.5,0,0,0-3,0v3H9a1,1,0,0,0-.8,1.6Z"
        fill={alpha(theme.palette.primary.main, 0.6)}
      />
    </svg>
  );
};
export default ReceiveIcon;
